/**
 * A divider between menu items.
 */
export const MenuItemDivider = () => <div className="-mx-3 my-2 h-px bg-border-secondary" />;
